/**
 * /app/$tenantSlug/hiring/costs — HR-admin hiring cost ledger +
 * cost-per-hire report (Wave K5.2).
 */

import { createFileRoute } from "@tanstack/react-router";
import { HiringModuleShell } from "@/components/shared/hiring-module-shell";
import { HiringFeatureGate } from "@/components/hiring/hiring-feature-gate";
import { CostsTab } from "@/components/hiring/costs-tab";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/hiring/costs",
)({
  component: HiringCostsRoute,
});

function HiringCostsRoute() {
  return (
    <HiringModuleShell
      title="Costs"
      description="Track spend and true cost-per-hire — no spreadsheet."
    >
      <HiringFeatureGate>
        <CostsTab />
      </HiringFeatureGate>
    </HiringModuleShell>
  );
}
